'use client';

import { useCallback, useMemo } from 'react';

import { FilterState } from '@/app/(main)/(pages)/busca/[slug]/_types/filter-state.type';
import { filtersToParamValues, parseFiltersFromParams } from '@/app/(main)/(pages)/busca/[slug]/_utils/search-filter-params.util';
import { useSearchParams } from '@/hooks/use-search-params.hook';

export function useSearchFilter() {
  const { getParam, setParams } = useSearchParams();

  const filters = useMemo<FilterState>(() => parseFiltersFromParams(getParam), [getParam]);

  const setFilters = useCallback(
    (next: Partial<FilterState>) => {
      setParams(filtersToParamValues({ ...filters, ...next }));
    },
    [filters, setParams],
  );

  return { filters, setFilters };
}
